import { Tooltip } from '@mui/material';

import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import { OnboardingStatusMap } from '../views/FirmBankingView/constants';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import NotStartedOutlinedIcon from '@mui/icons-material/NotStartedOutlined';

interface OnboardingStatusIconProps {
  status?: string;
  fontSize?: number;
}

export const getOnboardingStatusIcon =(status?: string) => {
  switch (status) {
    case 'COMPLETED':
      return CheckCircleOutlinedIcon;

    case 'IN_PROGRESS':
      return PendingOutlinedIcon;

    case 'BLOCKED':
      return RemoveCircleOutlineOutlinedIcon;

    case 'NOT_APPLICABLE':
      return BlockOutlinedIcon;

    case 'INVITE_SENT':
      return MarkEmailReadOutlinedIcon;

    case 'NOT_STARTED':
      return NotStartedOutlinedIcon;

    default:
      return BlockOutlinedIcon;
  }
};

const OnboardingStatusIcon = ({
  status = 'IN_PROGRESS',
  fontSize = 20,
}: OnboardingStatusIconProps) => {
  const normalizedStatus = status || 'IN_PROGRESS';

  const mappedStatus =
    OnboardingStatusMap[normalizedStatus as keyof typeof OnboardingStatusMap];

  if (!mappedStatus) {
    return null;
  }

  const Icon = getOnboardingStatusIcon(normalizedStatus);

  return (
    <Tooltip
      arrow
      title={mappedStatus.label}
      slotProps={{
        tooltip: {
          sx: (theme) => ({
            backgroundColor: theme.palette.common.white,
            color: theme.palette.primary.light,
            borderRadius: '5px',
            boxShadow: 3,
            fontFamily: 'Inter',
            fontSize: '13px',
            fontWeight: 500,
            padding: '5px 8px',
          }),
        },
        arrow: {
          sx: (theme) => ({
            color: theme.palette.common.white,
            '&:before': {
              boxShadow: 3,
            },
          }),
        },
      }}
    >
      <Icon
        sx={{
          color: mappedStatus.color,
          fontSize,
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
};

export default OnboardingStatusIcon;